import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiLogIn } from 'react-icons/fi';
import api from '../../lib/api';
import { setToken } from '../../lib/auth';
import styles from './AdminLogin.module.css';

const AdminLogin: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await api.post('/auth/login', { email, password });
      const token = res.data.token || res.data.accessToken;
      if (token) {
        setToken(token);
        navigate('/admin/dashboard');
      } else {
        setError('Invalid response from server');
      }
    } catch (err: any) {
      setError(
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        'Invalid credentials'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginPage}>
      <form className={styles.loginCard} onSubmit={handleSubmit}>
        <div className={styles.logo}>
          OFMIG<span>.SHOP</span>
        </div>
        <p className={styles.title}>{t('admin.login')}</p>

        <div className={styles.formGroup}>
          <label>{t('admin.email')}</label>
          <input
            type="email"
            className={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@ofmig.shop"
            required
          />
        </div>

        <div className={styles.formGroup}>
          <label>{t('admin.password')}</label>
          <input
            type="password"
            className={styles.input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="********"
            required
          />
        </div>

        <button
          type="submit"
          className={styles.submitBtn}
          disabled={loading}
        >
          <FiLogIn size={16} />
          {loading ? '...' : t('admin.signIn' as string) || t('admin.login')}
        </button>

        {error && <div className={styles.error}>{error}</div>}
      </form>
    </div>
  );
};

export default AdminLogin;
